import { BouncyChest } from "components/BouncyChest";
import usePopUpsV2 from "components/PopUpManagerV2/hooks/usePopUpsV2";
import PoisBountyStickyTag from "components/PoisBountyStickyTag";
import { RebateIcon } from "components/RebateOffer/RebateIcon";
import StickySaleTag from "components/StickySaleTag";
import { useEnvContext } from "contexts";
import { FeaturesFlags } from "helpers";
import { IconStack, Layer, TagsStack } from "./styles";
import { Hud } from "components/Hud";

const FloatingBottomLayer = () => {
	const { isFeatureFlagEnabled } = useEnvContext();
	const { stack } = usePopUpsV2();
	const isFtueV2Active = stack.some(
		({ variant }) =>
			variant === "tutorial-v2" || variant === "tutorial-loyalty-shop-v2"
	);
	const isHudEnabled =
		!isFtueV2Active && isFeatureFlagEnabled(FeaturesFlags.HUD_LIMITED_DEALS);
	const isBCStandaloneEnabled =
		!isHudEnabled &&
		!isFtueV2Active &&
		isFeatureFlagEnabled(FeaturesFlags.BOUNCY_CHEST);

	return (
		<Layer>
			{!isFtueV2Active && (
				<TagsStack>
					<PoisBountyStickyTag />
					<StickySaleTag />
				</TagsStack>
			)}
			<IconStack>
				{isHudEnabled && <Hud />}
				{isBCStandaloneEnabled && <BouncyChest />}
				{/* {isFeatureFlagEnabled(FeaturesFlags.REBATE) && <RebateIcon />} */}
				<RebateIcon />
			</IconStack>
		</Layer>
	);
};

export default FloatingBottomLayer;
